module.exports = __webpack_public_path__ + "assets/img/custom.8fec5c2a.jpg";